import { ArrowRight, Eye, Layers, Sparkles, Sprout } from 'lucide-react';
import { ADVERTISER_REGISTER_URL } from '../lib/links';
import { ctaClass } from '../lib/cta';

export function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_40%_at_50%_0%,var(--color-primary-soft)_0%,transparent_70%)] opacity-60"
      />
      <div className="relative mx-auto max-w-container-lg px-4 pb-20 pt-24 sm:px-6 sm:pt-28 lg:px-8 lg:pb-28 lg:pt-32">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-border-soft bg-surface px-3.5 py-1.5 text-xs font-semibold uppercase tracking-caps text-ink-secondary shadow-xs">
            <Sparkles className="h-3.5 w-3.5 text-primary" aria-hidden />
            Advertising for the attention era
          </span>

          <h1 className="mt-7 font-display text-5xl leading-display tracking-display text-ink sm:text-6xl lg:text-7xl">
            Put your brand in front of
            <br className="hidden sm:block" />{' '}
            <span className="italic text-primary">people who are paying attention.</span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-lg leading-body text-ink-secondary sm:text-xl">
            We help brands reach engaged audiences inside the games and experiences
            they love — campaigns that feel native, deliver real attention, and
            leave a lasting impression.
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <a href={ADVERTISER_REGISTER_URL} className={ctaClass('primary', 'lg')}>
              Start a campaign
              <ArrowRight className="h-5 w-5" aria-hidden />
            </a>
            <a href="#services" className={ctaClass('secondary', 'lg')}>
              See what we do
            </a>
          </div>

          <p className="mt-5 text-sm text-ink-muted">
            Free to get started · Pause or change direction anytime
          </p>
        </div>

        <HeroPromise />
      </div>
    </section>
  );
}

const PROMISES = [
  {
    icon: Layers,
    title: 'Feels native',
    body: 'Placements designed to fit the moment — never the kind people scroll past.',
  },
  {
    icon: Eye,
    title: 'Earns attention',
    body: 'Audiences are already focused. Your brand shows up while they are looking.',
  },
  {
    icon: Sprout,
    title: 'Leaves a mark',
    body: 'Native presence that keeps your brand top-of-mind long after the session ends.',
  },
];

function HeroPromise() {
  return (
    <div className="mx-auto mt-20 max-w-4xl">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
        {PROMISES.map(({ icon: Icon, title, body }) => (
          <div
            key={title}
            className="rounded-lg border border-border-soft bg-surface p-6 shadow-xs"
          >
            <div className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-primary-soft text-primary">
              <Icon className="h-5 w-5" aria-hidden />
            </div>
            <div className="mt-4 font-display text-xl leading-display text-ink">
              {title}
            </div>
            <p className="mt-1.5 text-base leading-body text-ink-secondary">{body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
